import React from "react";
import { Button as ChakraButton } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

export default function CTAButton({
  to,
  href,
  children,
  variant = "solid",
  size = "md",
  ...rest
}) {
  // Internal link using React Router
  if (to) {
    return (
      <ChakraButton
        as={RouterLink}
        to={to}
        variant={variant}
        size={size}
        {...rest}
      >
        {children}
      </ChakraButton>
    );
  }

  // External link or button behavior
  if (href) {
    return (
      <ChakraButton
        as="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        variant={variant}
        size={size}
        {...rest}
      >
        {children}
      </ChakraButton>
    );
  }

  // Regular button
  return (
    <ChakraButton variant={variant} size={size} {...rest}>
      {children}
    </ChakraButton>
  );
}
